/** B2B/B2C-Kennzeichen eines Kunden (Partner.unternehmer): true = Unternehmer, false = Privatkunde,
    null = unbekannt. Das Formular führt es als dreiwertige Auswahl (Radio-Gruppe). */
export type UnternehmerAuswahl = 'unternehmer' | 'privat' | 'unbekannt';

export function unternehmerAuswahl(wert: boolean | null | undefined): UnternehmerAuswahl {
  if (wert === true) return 'unternehmer';
  if (wert === false) return 'privat';
  return 'unbekannt';
}

export function unternehmerWert(auswahl: UnternehmerAuswahl): boolean | null {
  if (auswahl === 'unternehmer') return true;
  if (auswahl === 'privat') return false;
  return null;
}

/** Wert für den Request. Ein neuer Kunde, dessen Kennzeichen niemand angefasst hat, schickt KEIN Feld:
    dann gilt der Backend-Standard (mit USt-IdNr Unternehmer, sonst unbekannt). Beim Bearbeiten wird immer
    der angezeigte Wert gesendet — auch „unbekannt“ (null) als bewusste Entscheidung. */
export function unternehmerPayload(
  auswahl: UnternehmerAuswahl, istNeu: boolean, beruehrt: boolean,
): { unternehmer?: boolean | null } {
  if (istNeu && !beruehrt) return {};
  return { unternehmer: unternehmerWert(auswahl) };
}
